import {
   changePassword,
   counterBid,
   createBid,
   createCard,
   createCost,
   createLead,
   createTrip,
   deleteCard,
   deleteDraft,
   fetchCompanyOverview,
   fetchNotifications,
   fetchTerminals,
   fetchUnratedTrip,
   getCardList,
   getDraftTrips,
   getMe,
   getOngoingTrips,
   getPastTrips,
   getTrackSolidUrl,
   getTrip,
   getTripBids,
   getTripToken,
   getUnpaidTrips,
   getUpcomingTrips,
   getUploadUrl,
   getUserWithId,
   getVehicle,
   initiatePayment,
   loginUser,
   makeBidDecision,
   otpValidation,
   payForUnpaidTrips,
   rateTrip,
   readNotification,
   requestPasswordResetEmail,
   resendVerificationCode,
   resetPassword,
   saveToDraft,
   setActiveCard,
   signUp,
   trackTrip,
   updateDraft,
   updateTrip,
   updateTripStatus,
   updateUser,
   verifyUser,
} from "../redux/actions/mainActions"

export const reduxFunctions = {
   signUp,
   loginUser,
   changePassword,
   getMe,
   updateUser,
   getUploadUrl,
   requestPasswordResetEmail,
   resetPassword,
   createCost,
   getPastTrips,
   getTrip,
   createTrip,
   trackTrip,
   getOngoingTrips,
   getUpcomingTrips,
   updateTripStatus,
   getTripToken,
   initiatePayment,
   createCard,
   getCardList,
   deleteCard,
   setActiveCard,
   otpValidation,
   verifyUser,
   resendVerificationCode,
   fetchTerminals,
   createLead,
   createBid,
   getTripBids,
   makeBidDecision,
   counterBid,
   getUnpaidTrips,
   payForUnpaidTrips,
   saveToDraft,
   getDraftTrips,
   updateDraft,
   deleteDraft,
   rateTrip,
   fetchUnratedTrip,
   fetchCompanyOverview,
   updateTrip,
   fetchNotifications,
   readNotification,
   getUserWithId,
   getVehicle,
   getTrackSolidUrl,
}
